import React from "react";
import axios from "axios";
import domain from "../../../../domain";
import { Button } from "mdbreact";
const allEqual = (arr) => arr.every((v) => v === 1);
class UploadProducts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      file: null,
      status: false,
      file_upload_status: false,
      filecount: 0,
    };

    this.onChange = this.onChange.bind(this);
    this.fileUpload = this.fileUpload.bind(this);
  }

  folderValidate = (file) => {
    if (
      file.name.split(".")[1] === "JPG" ||
      file.name.split(".")[1] === "jpg" ||
      file.name.split(".")[1] === "png" ||
      file.name.split(".")[1] === "PNG"
    ) {
      return 1;
    } else {
      return 0;
    }
  };

  onChange(e) {
    this.setState({
      status: false,
    });
    let result = [];

    for (let i = 0; i < e.target.files.length; i++)
      result[i] = this.folderValidate(e.target.files[i]);
    let r = allEqual(result);

    if (r) {
      for (let i = 0; i < e.target.files.length; i++) {
        console.log(this.fileUpload(e.target.files[i]));
      }
    } else {
      this.setState({
        status: true,
      });
    }
  }
  async fileUpload(file) {
    let a = 0;
    var data = new FormData();

    data.append("photo_gallery", file);
    data.append("course_id", this.props.course.course_id);
    let r = await axios.post(
      `${domain.DBServer}/upload-photogallery/${this.props.course.course_id}`,
      data
    );
    console.log(r);
    if (r.data.success) {
      this.setState({
        filecount: this.state.filecount + 1,
      });
    } else {
      a = 0;
    }

    return a;
  }
  changeSate = (filecount) => {
    this.setState({
      filecount: filecount,
    });
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.state.filecount !== prevState.filecount)
      this.changeSate(this.state.filecount);
  }

  render() {
    return (
      <form>
        <div className="upload-btn-wrapper">
          <Button size="sm" gradient="aqua">
            Upload Directory{" "}
          </Button>
          <input
            type="file"
            onChange={this.onChange}
            directory=""
            webkitdirectory=""
          />
        </div>

        {this.state.status ? <div>Uploaded</div> : null}
        {this.state.filecount > 0 ? (
          <div>Uploaded ....{this.state.filecount} Files</div>
        ) : null}
      </form>
    );
  }
}

export default UploadProducts;
